import { withPlaceholder } from '../../Placeholders';
import { SingleRowPlaceholder } from '../../Placeholders/Templates';
import FiltersPopover from '../FiltersPopover';

export default withPlaceholder({
    customPlaceholder: SingleRowPlaceholder
})(FiltersPopover);
